import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, Action } from 'redux';

import { FirebaseActions, FirebaseSelectors, RemoteConfigService } from '@web_opxp/features';
import { DEFAULT_BLOG_PREVIEW } from '../../base/constants';
import ENV from '../../base/env';
import BlogPreview from './BlogPreview';

export default function BlogPreviewWrapper() {
  const firebaseReady = useSelector(FirebaseSelectors.isReady);
  const blogPreviewConfig = useMemo(() => {
    return firebaseReady
      ? RemoteConfigService.getObjectConfigValue(ENV.RemoteConfigBlogPreview, DEFAULT_BLOG_PREVIEW)
      : undefined;
  }, [firebaseReady]);
  const dispatch = useDispatch<Dispatch<Action<string>>>();

  useEffect(() => {
    if (!blogPreviewConfig) {
      return;
    }
    const { variant } = blogPreviewConfig;
    dispatch(FirebaseActions.setUserPropertyAction('experiment_5559', variant));
  }, [blogPreviewConfig, dispatch]);

  if (!blogPreviewConfig || !blogPreviewConfig.preview) {
    return null;
  }

  const { title, content, image_url, article_url } = blogPreviewConfig;

  return <BlogPreview title={title} content={content} imageUrl={image_url} articleUrl={article_url} />;
}
